










































import { Component, Vue } from 'vue-property-decorator'
import { queryStaffStyle } from '@/api/api'
import moment from 'moment'

@Component({})
export default class StaffPresence extends Vue {
  imgsGruop: Array<any> = [] // 图片组数据
  pageSize: number = 5 // 分页组件page-size
  total: number = 0 // 分页组件total

  mounted() {
    this._loading()
    this._queryStaffStyle().finally(() => {
      this._loading().close()
    })
  }

  fullscreen(e: any) {
    if (!e.target.webkitRequestFullScreen) {
      this.$message('该浏览器不支持视频全屏播放，是更换浏览器后重试～')
    }
    e.target.webkitRequestFullScreen()
  }

  /**
   * 换页
   */
  async changePage(page: number): Promise<any> {
    this._loading()
    await this._queryStaffStyle(page)
    this._loading().close()
  }

  /**
   * 查询员工风采
   * @param page 页码
   * @param size 数量
   */
  async _queryStaffStyle(page: number = 1, size: number = this.pageSize): Promise<any> {
    queryStaffStyle({ page, size }).then((res: any) => {
      if (res.data.code === 101) {
        const arr = res.data.result.records
        this.total = res.data.result.total
        this.imgsGruop = []
        for (let i = 0, len = arr.length, imgs, videos; i < len; i++) {
          if (/.+(\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4))$/i.test(arr[i].pic_path)) {
            imgs
          }
          arr[i].pics_path.filter((item: any) => /.+(\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4))$/i.test(item.pic_path))
          this.imgsGruop.push({
            date: moment(arr[i].ss_time).format('YYYY-MM-DD'),
            describe: arr[i].ss_desc,
            imgs: arr[i].pics_path.filter((item: any) => !/.+(\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4))$/i.test(item.pic_path)),
            videos: arr[i].pics_path.filter((item: any) => /.+(\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4))$/i.test(item.pic_path)),
            currentTab: 'image'
          })
        }
      }
    })
  }

  /**
   * 显示loading
   */
  _loading(text: string = '加载中'): any {
    const vm = this

    this.$loading({
      lock: true,
      text: text,
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return {
      close() {
        vm.$loading({}).close()
      }
    }
  }
}
